import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value: string;
  height?: number;
  displayValue?: boolean;
  className?: string;
}

/**
 * Código de barras Code128 renderizado en un canvas (escaneable con lector).
 */
export default function Barcode({ value, height = 50, displayValue = true, className }: BarcodeProps) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      JsBarcode(ref.current, value, {
        format: 'CODE128',
        height,
        displayValue,
        fontSize: 14,
        margin: 4,
        lineColor: '#111111',
        background: '#ffffff',
      });
    } catch {
      // Si el valor no es válido para Code128, se deja el canvas en blanco.
    }
  }, [value, height, displayValue]);

  return <canvas ref={ref} className={className} />;
}